module.exports = __webpack_public_path__ + "static/img/left-pic-3.f9dd787b.png";